import { useAPI, useAsyncHandler } from '~/hooks/common';

import type { TypePostUserLoginParams, TypePostUserLoginResponse } from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

const usePostUserLogin = () => {
  const { runAsync } = useAsyncHandler();

  const endPoint = '/api-owner/user/login';

  const postUserLogin = useAPI<TypePostUserLoginParams, TypePostUserLoginResponse>({
    endpoint: endPoint,
    method: 'post',
  });

  const requestUserLogin = async (
    { forceLoginFlag = false, ...params }: TypePostUserLoginParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypePostUserLoginResponse['data']) => Promise<void>;
      onError?: (error: TypeErrorResponseData['error']) => void;
    } = {}
  ) => {
    return runAsync(() => postUserLogin({ params: { ...params, forceLoginFlag } }), {
      onSuccess: async ({ data }) => await onSuccess?.(data),
      onError: (error) => onError?.(error as TypeErrorResponseData['error']),
    });
  };

  return { requestUserLogin };
};

export default usePostUserLogin;
